document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.content-comparison-cards .accordions').forEach(function (wrapper) {
    const accordions = wrapper.getElementsByClassName('accordion')

    function closeAccordion(accordion) {
      const button = accordion.querySelector('.accordion__button')
      const content = accordion.querySelector('.accordion__content')

      content.style.height = content.scrollHeight + 'px'
      content.offsetHeight // force reflow
      content.style.height = '0'

      accordion.classList.remove('accordion--active')
      button.setAttribute('aria-expanded', false)
      content.setAttribute('aria-hidden', true)
    }

    function openAccordion(accordion) {
      const button = accordion.querySelector('.accordion__button')
      const content = accordion.querySelector('.accordion__content')

      accordion.classList.add('accordion--active')
      button.setAttribute('aria-expanded', true)
      content.setAttribute('aria-hidden', false)

      content.style.height = content.scrollHeight + 'px'

      content.addEventListener('transitionend', function onEnd() {
        content.style.height = 'auto'
        content.removeEventListener('transitionend', onEnd)
      }, { once: true })
    }

    function closeAll() {
      for (let i = 0; i < accordions.length; i++) {
        closeAccordion(accordions[i])
      }
    }

    for (let i = 0; i < accordions.length; i++) {
      const accordion = accordions[i]
      const button = accordion.querySelector('.accordion__button')
      const content = accordion.querySelector('.accordion__content')

      content.style.height = '0'

      if (button.getAttribute('aria-expanded') === 'true') {
        accordion.classList.add('accordion--active')
        content.style.height = 'auto'
      }

      button.addEventListener('click', function (evt) {
        if (evt.target.tagName.toLowerCase() !== 'a') {
          const isActive = accordion.classList.contains('accordion--active')
          closeAll()
          if (!isActive) {
            openAccordion(accordion)
          }
        }
      })
    }
  })
})